import React from 'react';
import ReactDOM from 'react-dom/client'
import './css/index.css'
import App from './App'
import App_Iframe from './App_iframe'

const root = ReactDOM.createRoot(document.getElementById('root'))

// Check the environment variable to decide which component to render
const isAppSub = process.env.REACT_APP_USE_APP_SUB === 'true'

root.render(
    isAppSub ? <App_Iframe /> : <App />
)